import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  subject: Yup.object().required('person_required'),
  rating: Yup.number().required('rating_required'),
  tournament: Yup.object().required('tournament_required'),
  file: Yup.mixed().required('evaluation_file_required'),
});
